import classNames from "classnames";
import React from "react";
import ContentLoader from "react-content-loader";
import "./index.scss";

export interface ISpecialTitleProps {
  className?: string;
  children: React.ReactNode;
  size?: "normal" | "large";
}

const SpecialTitle = ({
  children,
  className,
  size = "normal",
}: ISpecialTitleProps) => {
  const loader = (
    <ContentLoader
      className="special__loader"
      height={20}
      width={100}
      speed={5}
    >
      <rect x="0" y="4" rx="10" ry="10" width="90" height="12" />
    </ContentLoader>
  );

  return (
    <div
      className={classNames(
        `special__title special__title--${size}`,
        className,
      )}
    >
      {children || loader}
    </div>
  );
};

export default SpecialTitle;
